import {EvalEnv, PluginsContext} from '@packages/systems/wfdl';
import {
  localesListActiveItemVariable,
  LocaleItemContext,
} from '@packages/shared/constants/Render';
import {weakMemo, singleMemo} from '@packages/utilities/memo';

export const updateEnvForLocalizationActiveLocale = weakMemo(
  (evalEnv: EvalEnv.EvalEnvType) =>
    singleMemo((activeLocale: LocaleItemContext | null) => {
      if (!activeLocale) return evalEnv;

      return EvalEnv.insertValue(
        evalEnv,
        localesListActiveItemVariable,
        activeLocale
      );
    })
);

export function getActiveLocale(
  pluginsContext: PluginsContext
): LocaleItemContext | null {
  return pluginsContext.getIn(['Localization', 'currentLocale']);
}
